__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "nexway-tpdigital-mf-host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("./src/api/index.ts", "0", () => (() => (__webpack_require__(6629))), 1);
			register("@celebration/react", "1.11.9", () => (() => (__webpack_require__(3225))), 1);
			register("@reduxjs/toolkit", "1.9.7", () => (() => (__webpack_require__(2621))), 1);
			register("axios", "1.15.2", () => (() => (__webpack_require__(4344))), 1);
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(7950))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(2166))), 1);
			register("react-router-dom", "6.22.3", () => (() => (__webpack_require__(6220))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(5043))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(805))), 1);
			register("styled-components", "6.1.8", () => (() => (__webpack_require__(5335))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};